import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {CreditorBankAccountDto} from "../../../../model/dto/entity/creditor-bank-account.dto";
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {ObjectIdentifier} from "../../../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../../../core/shared/basic/object-identifier-data";

@Component({
    selector: 'bm-creditor-bank-account-base',
    template: '',
    standalone: false
})
export class BmCreditorBankAccountBaseComponentBase extends ObjectBaseModeComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    dto: CreditorBankAccountDto;

    hideFilters: boolean = true;
    panelVisible: boolean = false;
    activeIndex: number = 0
    isLeftExpanded: boolean = true;

    selectedObject: ObjectIdentifier;

    constructor(protected route: ActivatedRoute) {
        super(route)
    }

    ngOnInit(): void {
    super.ngOnInit();
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }


    togglePanel(event: boolean) {
        this.panelVisible = !this.panelVisible;
    }

    hideFilterSection() {
        this.hideFilters = !this.hideFilters;
    }

    handleObjectSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        this.isLeftExpanded = false;

        this.selectedObject = new ObjectIdentifier(event.objectType, event.objectId);

        // const navigationObject = MvsObjectNavigationEntry.createNavigationEntry(event.objectType, event.objectId, null, null, null, null, MvsObjectNavigationActionEnum.any, 'full');
        // this.navigationService.openObjectInNewTab(navigationObject);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
